var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.visible_models),function(desc,ind){return [(_vm.active_model.endsWith(desc.key))?_c('model',{key:ind,ref:desc.key,refInFor:true,attrs:{"id":_vm.id,"desc":desc,"group_id":_vm.group_id,"data":_vm.data}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }